import React from 'react';

type IconLibraryProps = React.ComponentProps<'svg'> & {
  type: 'ruler' | 'door';
};

const IconLibrary = ({
  type,
  ...props
}: IconLibraryProps): React.JSX.Element => {
  if (type === 'ruler') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 22 21"
        {...props}
      >
        <path
          fill="currentColor"
          d="M21.463 10.987l.101.01c.229.047.401.25.401.495v9.003a.503.503 0 01-.502.505H.57a.503.503 0 01-.502-.505v-9.004l.01-.101a.503.503 0 01.492-.403h20.894zm-3.119 2.961v-1.952H16.74v3.908a.503.503 0 01-.502.504.503.503 0 01-.501-.504v-3.908H14.13v1.954a.503.503 0 01-.501.504.503.503 0 01-.502-.504v-1.954h-1.61v3.908a.503.503 0 01-.502.504.503.503 0 01-.502-.504v-3.908h-1.61v1.954a.503.503 0 01-.501.504.503.503 0 01-.502-.504v-1.954H6.292v3.913a.503.503 0 01-.502.504.503.503 0 01-.502-.504v-3.913H3.682v1.958a.504.504 0 01-.502.504.504.504 0 01-.501-.504v-1.958H1.07v7.995h19.89v-7.995h-1.613v1.952a.503.503 0 01-.502.504.503.503 0 01-.502-.504zm3.117-10.697l.101.01a.505.505 0 010 .99l-.1.01H.571a.503.503 0 01-.5-.505c0-.279.224-.505.5-.505h20.89z"
        />
        <path
          fill="currentColor"
          d="M.172 3.376a.5.5 0 01.631-.065l.079.065 3.2 3.217.064.08a.507.507 0 01-.064.634.5.5 0 01-.631.064l-.08-.064L.173 4.09l-.066-.08a.507.507 0 01.065-.634z"
        />
        <path
          fill="currentColor"
          d="M3.426.083a.5.5 0 01.63.065.507.507 0 010 .713L.857 4.08l-.078.064a.5.5 0 01-.631-.064.508.508 0 010-.715l3.2-3.217.079-.065zm14.492.065a.5.5 0 01.631-.065l.079.065 3.2 3.217.064.08a.507.507 0 01-.064.635.5.5 0 01-.63.064l-.08-.064-3.2-3.219-.064-.078a.507.507 0 01.064-.635z"
        />
        <path
          fill="currentColor"
          d="M21.222 3.31a.5.5 0 01.631.066.507.507 0 010 .713l-3.2 3.218-.079.064a.5.5 0 01-.63-.064.508.508 0 010-.714l3.199-3.217.08-.065zm.241 7.677l.101.01c.229.047.401.25.401.495v9.003a.503.503 0 01-.502.505H.57a.503.503 0 01-.502-.505v-9.004l.01-.101a.503.503 0 01.492-.403h20.894zm-3.119 2.961v-1.952H16.74v3.908a.503.503 0 01-.502.504.503.503 0 01-.501-.504v-3.908H14.13v1.954a.503.503 0 01-.501.504.503.503 0 01-.502-.504v-1.954h-1.61v3.908a.503.503 0 01-.502.504.503.503 0 01-.502-.504v-3.908h-1.61v1.954a.503.503 0 01-.501.504.503.503 0 01-.502-.504v-1.954H6.292v3.913a.503.503 0 01-.502.504.503.503 0 01-.502-.504v-3.913H3.682v1.958a.504.504 0 01-.502.504.504.504 0 01-.501-.504v-1.958H1.07v7.995h19.89v-7.995h-1.613v1.952a.503.503 0 01-.502.504.503.503 0 01-.502-.504z"
        />
        <path
          fill="currentColor"
          d="M21.461 3.251l.101.01a.505.505 0 010 .99l-.1.01H.571a.503.503 0 01-.5-.505c0-.279.224-.505.5-.505h20.89z"
        />
        <path
          fill="currentColor"
          d="M.172 3.376a.5.5 0 01.631-.065l.079.065 3.2 3.217.064.08a.507.507 0 01-.064.634.5.5 0 01-.631.064l-.08-.064L.173 4.09l-.066-.08a.507.507 0 01.065-.634z"
        />
        <path
          fill="currentColor"
          d="M3.426.083a.5.5 0 01.63.065.507.507 0 010 .713L.857 4.08l-.078.064a.5.5 0 01-.631-.064.508.508 0 010-.715l3.2-3.217.079-.065zm14.492.065a.5.5 0 01.631-.065l.079.065 3.2 3.217.064.08a.507.507 0 01-.064.635.5.5 0 01-.63.064l-.08-.064-3.2-3.219-.064-.078a.507.507 0 01.064-.635z"
        />
        <path
          fill="currentColor"
          d="M21.222 3.31a.5.5 0 01.631.066.507.507 0 010 .713l-3.2 3.218-.079.064a.5.5 0 01-.63-.064.508.508 0 010-.714l3.199-3.217.08-.065z"
        />
      </svg>
    );
  } else if (type === 'door') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 21 22"
        {...props}
      >
        <path
          fill="currentColor"
          d="M8.5 9a.5.5 0 01.5.5v4a.5.5 0 01-1 0v-4a.5.5 0 01.5-.5zm4 0a.5.5 0 01.5.5v4a.5.5 0 01-1 0v-4a.5.5 0 01.5-.5z"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M21 22H0V0h21v22zM1 21h9V1H1v20zm10 0h9V1h-9v20z"
          clipRule="evenodd"
        />
      </svg>
    );
  }

  return <></>;
};

export { IconLibrary, type IconLibraryProps };
